import type { IInstrumentationLoader } from './Interfaces';

export class InstrumentationLoader implements IInstrumentationLoader {
  public async loadInstrumentationLibraryAsync(url: string): Promise<Record<string, unknown>> {
    const value = await fetch(import.meta.env.BASE_URL + url);
    const data = await value.blob();
    const buffer = await data.arrayBuffer();
    const view = new Uint8Array(buffer);
    for (let i = view.length - 1; i >= 0; --i) {
      view[i] ^= 224; // decrypt JSON (see vite.config.ts)
    }
    const jsonStr = new TextDecoder().decode(view);
    const json = JSON.parse(jsonStr) as Record<string, unknown>;
    return json;
  }
}
